import { SET_CHAT_DATA } from '../mutation-types';
const mutations = {
    [SET_CHAT_DATA](state, value) {
        state.termsConditions = value.termsConditions;
        state.footerElems = value.footerElems;
    },
};
export default mutations;
